import {Box, Button, IconButton, TextField} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ListView from "../components/ListView/ListView";
import LoadingContent from "../components/ui/LoadingContent";
import Window from "../components/Window/Window";
import {m2mTokenColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import usePaginationSearch from "../hooks/usePaginationSearch";
import {useNavigate} from "react-router-dom";
import {useCallback} from "react";

const M2MTokens = () => {
  const {loading, list} = useApiRequest({baseUrl: "/m2m-tokens", resource: "m2m_tokens"});

  const fetcher = useCallback(
    async (query) => {
      try {
        const {success, data} = await list({...query});
        if (!success) return null;

        return {data};
      } catch (error) {
        console.error("Error al cargar los M2M tokens:", error);
        return null;
      }
    },
    [list]
  );
  const {filters, setFilter, applyFilters, resetFilters, dataGridProps} = usePaginationSearch({
    fetcher
  });
  const navigate = useNavigate();

  const handleCopyToken = async (token) => {
    try {
      await navigator.clipboard.writeText(token);
      console.log("Token copiado al portapapeles");
      // Opcional: agregar notificación de éxito aquí
    } catch (err) {
      console.error("Error al copiar:", err);
    }
  };

  const columns = [
    ...m2mTokenColumns,
    {
      field: "actions",
      headerName: "Copiar",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="copy"
          color="primary"
          onClick={(e) => {
            e.stopPropagation();
            handleCopyToken(params.row.token);
          }}
        >
          <ContentCopyIcon />
        </IconButton>
      )
    }
  ];

  return (
    <Window title={" M2M Tokens"}>
      {loading ? (
        <LoadingContent />
      ) : (
        <>
          <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" marginBottom={2}>
            <TextField
              label="Buscar domain"
              variant="outlined"
              margin="normal"
              style={{width: "250px"}}
              value={filters.domain || ""}
              onChange={(e) => {
                setFilter("domain", e.target.value);
              }}
            />
            <Button variant="contained" onClick={applyFilters}>
              Buscar
            </Button>
            <Button variant="contained" onClick={resetFilters}>
              Resetear
            </Button>
          </Box>
          <ListView
            columns={columns}
            getRowId={(row) => row.id}
            loading={loading}
            dataGridProps={dataGridProps}
            TopRigthButtons={
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate(`/m2m-tokens-form`);
                }}
              >
                Nuevo M2M Token
              </Button>
            }
          />
        </>
      )}
    </Window>
  );
};

export default M2MTokens;
